import React from 'react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-sans transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-300';
  const variants = {
    primary: 'bg-charcoal text-ivory hover:bg-black hover:shadow-lg',
    secondary: 'bg-purple-200 text-charcoal hover:bg-purple-300',
    outline: 'border border-charcoal text-charcoal hover:bg-charcoal hover:text-ivory',
    ghost: 'text-charcoal hover:bg-purple-100'
  };
  const sizes = {
    sm: 'px-6 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-708" data-mp="82wgy9lqirxx">
      {children}
    </button>;
}